import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import moment from 'moment';
import { format } from 'date-fns';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';

@Component({
    selector: 'app-detalhes-container',
    templateUrl: './detalhes-container.component.html',
    styleUrls: ['./detalhes-container.component.css'],
    standalone: false
})
export class DetalhesContainerComponent implements OnInit {
  
  item: any = {};
  items: any[] = [];
  filtereditems: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  query: string = 'TransportadoresFreteExtra';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  queryDistancias: string = 'DistanciasContainer';
  queryPesos: string = 'PesosContainer';
  querylocation: string = 'Fornecedores_Karrara_Transport';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  existingExcelFile: string = 'C:/Users/ssbuif/Desktop/Transport Instruction-teste.xlsx';
  locais!: any[]
  dialogOpen: boolean = false;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  isLoading: boolean = true;
  isUserEnabled: boolean = false;
  isAdminEnabled: boolean = false;
  locationDeliveryChanged!: boolean;
  locationPickupChanged!: boolean;
  subscription: Subscription | undefined;
  // endDate: string | number | Date;
  endDate: Date = new Date();
  startDate: Date = new Date();
  endDateIni: Date = new Date();
  startDateIni: Date = new Date();
  startDateFilter!: Date;// Data de início do intervalo selecionado
  endDateFilter!: Date; // Data de término do intervalo selecionado
  dateInicial = new Date('1970-01-02')
  temCaracterEspecial: boolean = false;
  allItems: any[] = [];
  dialogOpenPercurso: boolean = false;
  dialogOpenPesos: boolean  = false;


  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  pesosContainer!: any[];
  distanciasContainer!: any[];

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit(): Promise<void> {
    if (!this.item.veiculo) {
      this.item.veiculo = [];
    }
    await this.getUsers()
    await this.getUserLogado()
    // await this.getItemsFromOrigin();
    // await this.getCarriers();
    await this.enableFields();
    await this.getPesos();
    await this.getDistancias();
    // await this.getItemsFromDynamoDB();
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.upDate()
      await this.enableFields();
      this.isLoading = false;    
    });

  }

  async upDate() {
    // await this.getItemsFromDynamoDB();
    // await this.getItemsFromOrigin();
    await this.getPesos();
    await this.getDistancias();
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
  }

  editPercurso(item: any, index:number): void {
    // console.log(item)
    this.campoTocado = false;
    this.enableFields();
    this.item.ID = item.ID;
    this.item.transportadora = item.transportadora;
    this.item.veiculo = item.veiculo;
    this.dialogOpenPercurso = true;
  }

  editPeso(item: any, index:number): void {
    // console.log(item)
    this.campoTocado = false;
    this.enableFields();
    this.item.ID = item.ID;
    this.item.transportadora = item.transportadora;
    this.item.veiculo = item.veiculo;
    this.dialogOpenPesos = true;
  }

  solicitarFrete() {
    this.item = [];
    this.item.ID = format(new Date(), 'ddMMyyyyHHmmss');
    this.dialogOpen = true;
    if (!this.item.veiculo) {
      this.item.veiculo = [];
    }
    //console.log(this.item.date)
  }

  verificarCaracteresEspeciais() {
    // Utiliza uma expressão regular para verificar caracteres especiais
    this.temCaracterEspecial = /[^\w\s]/.test(this.item.description);
  }

  async salvar2(item: any) {
    // console.log(item)
    // console.log(this.item)
    this.isLoading = true;
    try {    
        const objetoParaSalvar = {
          "ID": this.item.ID,
          "transportadora": this.item.transportadora,
          "validade": this.item.validade,
          "tableName":this.query
          // Adicione outras propriedades conforme necessário
        };
  
        // Adicione o objeto à tabela especificada
        objetoParaSalvar.tableName = this.query;  
        // Converte o objeto para uma string JSON
        const objetoString = JSON.stringify(objetoParaSalvar);  
        // Remove barras invertidas escapadas
        const objetoSemEscape = objetoString.replace(/\\"/g, '"');  
        // Converte a string JSON para um objeto JavaScript
        const objetoFinal = JSON.parse(objetoSemEscape);  
        // Chama o serviço para salvar no DynamoDB (ou serviço similar)
        await this.dynamodbService.salvar([objetoFinal], this.query, this.urlAtualiza)
          .subscribe(async response => {
            // console.log(response);
            await this.upDate();
            this.dialogOpen = false;
            this.isLoading = false;
          }, error => {
            console.log(error);
          });
    } catch (error) {
      const confirmacao = window.confirm("Por favor, revise o preenchimento do formulário!");
      if (confirmacao) {
        this.isLoading = false;
        console.error('Error :', error);
      }
    }
  }

  clearFilter() {
    this.filtereditems = this.itemsCompletos;
    this.dateInput.nativeElement.value = '';
    this.dateInput2.nativeElement.value = '';
    this.startDateFilter = this.dateInicial
    this.endDateFilter = this.dateInicial
    // //console.log(this.startDateFilter)
  }

  formatarComoMoeda(valor: string): string {
    try{
    const valorNumerico = parseFloat(valor.replace(',', '.'));

    if (!isNaN(valorNumerico)) {
      return valorNumerico.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } else {
      return valor;
    }
  }
    catch{
      return valor;
    }
  }

  async applyFilter() {
    if (this.startDateFilter && this.endDateFilter) {
      this.startDate = new Date(this.startDateFilter); // Certifique-se de que this.startDate seja um valor válido no formato de data
      this.startDate.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos para zero
      this.startDate.setDate(this.startDate.getDate() + 1); // Acrescenta um dia
      // //console.log(this.startDate)
      this.endDate = new Date(this.endDateFilter);
      this.endDate.setHours(0, 0, 0, 0);
      this.endDate.setDate(this.endDate.getDate() + 1); // Acrescenta um dia
      // //console.log(this.endDate)
      this.filtereditems = await this.items.filter(item => {
        const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
        itemDate.setHours(0, 0, 0, 0);
        return itemDate >= this.startDate && itemDate <= this.endDate;
      });
    } else {
      this.filtereditems = this.items;
    }
  }

  async aplicarFiltro() {
    if (!this.searchString) {
      if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
        this.filtereditems = await this.items.filter(item => {
          const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
          itemDate.setHours(0, 0, 0, 0);
          return itemDate >= this.startDate && itemDate <= this.endDate;
        });
      } else {
        this.filtereditems = this.items;
      }
    }
    this.filtereditems = this.filtereditems.filter(item => this.filtrarItem(item));
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }

    const lowerCaseFilter = this.searchString.toLowerCase();

    // Verificar se alguma propriedade do item corresponde ao filtro (ignorando maiúsculas e minúsculas)
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  } 
 
  async getPesos(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryPesos, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.pesosContainer = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getDistancias(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryDistancias, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.distanciasContainer = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.usuarios = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }


  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
    this.locationDeliveryChanged = false;
    this.locationPickupChanged = false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log(this.usuarioLogado)
  }


  // async getItemsFromOrigin(): Promise<void> {
  //   const filtro = '';
  //   (await this.dynamodbService.getItems(this.querylocation, this.urlConsulta, filtro)).subscribe(
  //     async (response: any) => {
  //       if (response.statusCode === 200) {
  //         try {
  //           const items = JSON.parse(response.body);
  //           if (Array.isArray(items)) {
  //             this.itemsOrigin = items.map(item => ({ ...item, checked: false }));

  //             // Ordena os itens em ordem alfabética com base na propriedade 'local'
  //             await this.itemsOrigin.sort((a, b) => a.local.localeCompare(b.local));

  //             // Salva os locais ordenados em this.placesOrigin
  //             this.placesOrigin = this.itemsOrigin.map(item => item.local);
  //             this.locais = items;
  //             // //console.log(this.placesOrigin)
  //             // //console.log(items)                          
  //           } else {
  //             console.error('Invalid items data:', items);
  //           }
  //         } catch (error) {
  //           console.error('Error parsing JSON:', error);
  //         }
  //       } else {
  //         console.error('Invalid response:', response);
  //       }
  //     },
  //     (error: any) => {
  //       console.error(error);
  //     }
  //   );
  // }


  // async getItemsFromDynamoDB(): Promise<void> {
  //   try {
  //     const lambdaEvent = {
  //       "tableName": "TransportadoresFreteExtra",
  //       "searchConditions": [
  //         // { "column": "status", "word": "Completed", "negate": true },
  //         // { "column": "status", "word": "Canceled", "negate": true },
  //         // { "column": "Finalizada", "word": "true", "negate": true },
  //         // { "column": "Finalizada", "word": "True", "negate": true },
  //         // { "column": "ID", "word": "", "negate": true }
  //       ]
  //     };
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });
  //     if (response.statusCode == 200) {
  //       try {
  //         // //console.log(response.body)
  //         const items = await JSON.parse(response.body);
  //         this.allItems = items;
  //         // console.log(items)
  //         if (Array.isArray(items)) {
  //           this.items = items;
  //                this.itemsCompletos = this.items;
  //             this.cdr.detectChanges();
  //         } else {
  //           console.error('Invalid items data:', items);
  //         }
  //       } catch (error) {
  //         console.error('Error parsing JSON:', error);
  //       }
  //     } else {
  //       console.error('Invalid response:', response);
  //     }
  //   } catch (error) {
  //     console.error('Error parsing JSON:', error);
  //   }
  // }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir este registro?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          await this.upDate();
          // await this.getItemsFromDynamoDB();
          this.isLoading = false;
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  adicionarDailyCost() {
    // Adiciona um novo campo com scperiod: 0
    this.item.veiculo.push({ km0a50: 0.0, km51a100:0.0, km101a200: 0.0, km201a500: 0.0, km501a1000: 0.0, km1000: 0.0 });
  }

  removerDailyCost(index: number) {
    this.item.veiculo.splice(index, 1);
  }
}

